export const config = {
  clientId: import.meta.env.PUBLIC_CL_CLIENT_ID,
  clientSecret: import.meta.env.CL_CLIENT_SECRET,
  scope: import.meta.env.PUBLIC_CL_CLIENT_SCOPE,
  endpoint: import.meta.env.PUBLIC_CL_ENDPOINT,
  admin: {
    clientId: import.meta.env.CL_ADMIN_CLIENT_ID,
    clientSecret: import.meta.env.CL_ADMIN_CLIENT_SECRET,
  },
}
